export const setLocalStorage = (itemName, object) => {
    localStorage.setItem(itemName, JSON.stringify(object));
}

export const getLocalStorage = (itemName, ifEmptyReturn) => {
    const localStorageData = JSON.parse(localStorage.getItem(itemName));
    if (localStorageData) return localStorageData;

    if (ifEmptyReturn === 'undefined'){
        return undefined;
    } else if (ifEmptyReturn === 'array'){
        return [];
    } else if (ifEmptyReturn === 'openweather') {
        return 'openweather';
    }
    
    return false;
}
